import React, { useState, useEffect } from "react";
import { fetchProfileData, updateProfile } from "../../API/axiosClient";
import avtar2 from "../../image/avtar2.png";
import { imageprofiledefault } from "../../imgUrl";
import { Link } from "react-router-dom";

const Viewprofile = () => {
  const [profileData, setProfileData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    files: null,
  });
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  // const BASE_URL = "http://18.233.85.48:8080/api/";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchProfileData();
        setProfileData(data);
        setFormData({
          name: data.name,
          email: data.email,
          mobile: data.mobile,
          files: null,
        });
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchData();
  }, []);

  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "files") {
      const file = files[0];
      setFormData((prevState) => ({
        ...prevState,
        [name]: file,
      }));
      setImagePreview(URL.createObjectURL(file)); // Set a preview URL
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSaveChanges = async () => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("mobile", formData.mobile);
      if (formData.files) {
        formDataToSend.append("files", formData.files); // Append file if it exists
      }

      // Log the formData to check its content
      for (let pair of formDataToSend.entries()) {
        // console.log(`${pair[0]}: ${pair[1]}`);
      }

      await updateProfile(formDataToSend); // Ensure this sends a multipart request
      setShowSuccessMessage(true);
      setEditMode(false);

      // Update the profileData state with the new data
      setProfileData((prevData) => ({
        ...prevData,
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        profile: formData.files ? URL.createObjectURL(formData.files) : prevData.profile,
      }));
    } catch (error) {
      console.error("Error updating profile data:", error);
    }
  };

  const handleOkClick = () => {
    setShowSuccessMessage(false); // Close the success message
  };

  return (
    <div>
      <div>
        {profileData ? (
          <>
            <div
              className="pop-but"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              <div className="div-imf-main d-flex">
                <div className="div-imf">
                  <img src={ profileData.profile} alt={profileData.name} />
                </div>
                <div className="div-imf-text">
                  <h3>{profileData.name}</h3>
                  <ul>
                    <li>
                      <Link href="">UHID :&nbsp;{profileData._id}</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </>
        ) : (
          <p>Loading profile data...</p>
        )}
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              {showSuccessMessage ? (
                <div className="text-center p-4">
                  <img
                    src={avtar2}
                    alt="Profile Icon"
                    className="rounded-circle mb-3"
                  />
                  <h5 className="text-success">Profile Updated Successfully</h5>
                  <button
                    type="button"
                    className="btn btn-success ms-3"
                    data-bs-dismiss="modal"
                    onClick={handleOkClick}
                  >
                    OK
                  </button>
                </div>
              ) : profileData ? (
                editMode ? (
                  <div className="form-container">
                    <div className="crat">
                      <span id="red">My profile</span>
                      <button
                        id="btnCloseForm"
                        className="close-button"
                        data-bs-dismiss="modal"
                      >
                        <svg
                          id="btnCloseForm"
                          xmlns="http://www.w3.org/2000/svg"
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M1 1L19 19M1 19L19 1"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>

                    <form>
                      <div className="form-group">
                        <div
                          className="in-img"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={
                              imagePreview ||
                              profileData.profile ||
                              imageprofiledefault
                            }
                            alt="Profile"
                            className="profile"
                          />

                          <input
                            type="file"
                            name="files"
                            onChange={handleInputChange}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="fullName">Full Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="fullName"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="Name"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="mobile">Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          id="mobile"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleInputChange}
                          placeholder="Mobile"
                        />
                      </div>

                      <div className="button-pro">
                        <button
                          type="button"
                          onClick={() => setEditMode(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="active"
                          type="button"
                          onClick={handleSaveChanges}
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                ) : (
                  <div className="form-container">
                    <div className="crat">
                      <span id="red">My profile</span>
                      <button
                        id="btnCloseForm"
                        className="close-button"
                        data-bs-dismiss="modal"
                      >
                        <svg
                          id="btnCloseForm"
                          xmlns="http://www.w3.org/2000/svg"
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M1 1L19 19M1 19L19 1"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    <form action="">
                      <div className="form-group">
                        <label htmlFor="">Full Name</label>
                        <br />
                        <span>{profileData.name}</span>
                      </div>
                      <div className="form-group">
                        <label htmlFor="">Mobile</label>
                        <br />
                        <span>{profileData.mobile}</span>
                      </div>
                      <div className="form-group">
                        <label htmlFor="" id="darkred" className="mb-0">
                          Important:{" "}
                        </label>
                        <span id="syan">
                          You cannot edit these details once you have saved
                          them. They will appear on all your medical documents.
                          Do you wish to confirm?
                        </span>
                      </div>
                      <div className="button-pro">
                        <button type="button" onClick={handleEditClick}>
                          EDIT
                        </button>
                        <button
                          className="active"
                          type="button"
                          data-bs-dismiss="modal"
                        >
                          CONFIRM
                        </button>
                      </div>
                    </form>
                  </div>
                )
              ) : (
                <p>Loading profile data...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewprofile;
